import { render, staticRenderFns } from "./CoverStory.vue?vue&type=template&id=608e5865&"
import script from "./CoverStory.vue?vue&type=script&lang=js&"
export * from "./CoverStory.vue?vue&type=script&lang=js&"
import style0 from "./CoverStory.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports